import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';
import CartItemModel from 'src/model/cartItem.model';
import AddressModel from 'src/model/address.model';

export interface ICartError {
  hasFailed: boolean;
  message: string;
}
export interface ICartSuccess {
  hasSucced: boolean;
  message: string;
}

const INITIAL_ITEMS = INITIAL_STATE.cart.items || {};
const INITIAL_ITEM_COUNT = 0;
const INITIAL_IS_PENDING = false;
const INITIAL_IS_PENDING_LIST = true;
const INITIAL_IS_FILE_STATUS = true;
const INITIAL_UPDATING = false;
const INITIAL_ERROR: ICartError = {
  hasFailed: false,
  message: ''
};
const INITIAL_SUCCESS: ICartSuccess = {
  hasSucced: false,
  message: ''
};

const delivery = (
  state: string = 'Shipping',
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_DELIVER_METHOD:
      return payload;

    default:
      return state;
  }
};

const deliveryLocation = (
  state: AddressModel | null = null,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_DELIVER_TO:
      return payload;

    default:
      return state;
  }
};

const deliveryLocationCode = (
  state: string = null,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_DELIVERY_LOCATION_CODE:
      return payload;

    default:
      return state;
  }
};
const suppliedFromCode = (
  state: string = null,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_SUPPLIED_FROM_CODE:
      return payload;

    default:
      return state;
  }
};

const subTotal = (
  state: number = 0,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_SUBTOTAL:
      return payload;

    default:
      return state;
  }
};

const itemCount = (
  state: number = INITIAL_ITEM_COUNT,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ITEMS_COUNT:
      return payload;

    default:
      return state;
  }
};

const items = (
  state: IInitialState['cart']['items'] = INITIAL_ITEMS,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.CLEAR_ALL:
      return {};
    case types.ITEM_REMOVE: {
      const { [payload]: item, ...withoutItem } = state;
      return withoutItem;
    }
    case types.SET_ITEMS:
      return payload;
    case types.ADD_ITEM: {
      const item = payload as CartItemModel;
      return {
        ...state,
        [item.id]: item
      };
    }
    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};
const updating = (
  state: boolean = INITIAL_UPDATING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_UPDATING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: ICartError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const success = (
  state: ICartSuccess = INITIAL_SUCCESS,
  {
    type,
    payload
  }: {
    type: string;
    payload: ICartSuccess;
  }
) => {
  switch (type) {
    case types.SET_SUCCESS_CART:
      return payload;

    default:
      return state;
  }
};

const isDownloadingPdf = (
  state: boolean = false,
  { type, payload }: { type: string; payload: boolean }
) => {
  switch (type) {
    case types.SET_CART_IS_DOWNLOADING_PDF:
      return payload;

    default:
      return state;
  }
};

const isPendingList = (
  state: boolean = INITIAL_IS_PENDING_LIST,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING_LISTS:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const isFileStatus = (
  state: boolean = INITIAL_IS_FILE_STATUS,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING_FILE_STATUS:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

export default combineReducers({
  delivery,
  deliveryLocation,
  deliveryLocationCode,
  suppliedFromCode,
  subTotal,
  itemCount,
  items,
  isPending,
  updating,
  error,
  success,
  isDownloadingPdf,
  isPendingList,
  isFileStatus
});
